module.exports = __webpack_public_path__ + "img/电话@2x.902ab457.png";